(function() {
    'use strict';

    angular
        .module('sodCommon')
        .provider('RmsEnum', providerFunc);

    function providerFunc() {
        let path = '/api/v1/form/enum/getEnum/';
        const enums = {};

        providerGetFunc.$inject = ['$http', 'lodash'];
        return {
            $get: providerGetFunc,
            changePath: function(_p) {
                path = _p;
            }
        };


        function providerGetFunc($http, lodash) {
            return {
                load: function(enumName) {
                    return $http.post(path + enumName, {}).then(function(res) {
                        lodash.set(enums, enumName, res.data.data);
                        return res.data.data;
                    }, function (err) {
                        return err;
                    });
                },
                get: function (enumName, value, defaultValue) {
                    const result = lodash.find(lodash.get(enums, enumName, []), function(row) {
                        return value.toString() === row.value.toString();
                    });
                    if (result) {
                        return result.label;
                    }
                    return defaultValue;
                },
                setList: function(enumName, list) {
                  lodash.set(enums, enumName, list);
                },
                getList: function(enumName) {
                    if (lodash.has(enums, enumName)) {
                        return lodash.get(enums, enumName, []);
                    }
                    return this.load(enumName).then(function(res) {
                        return res;
                    })
                },
                has: function(enumName) {
                    return lodash.has(enums, enumName);
                }
            };
        }
    }
})();